import axios from "axios";

import fetchPonyfill from "fetch-ponyfill";
const { fetch } = fetchPonyfill();

const BASE_URL = "https://europe-north1-moocfi.cloudfunctions.net/api";

const OPT_OUT_STRINGS = ["false", "no", "opt-out", "disallowed", "f", "0"];
const OPT_IN_STRINGS = ["true", "yes", "opt-in", "allowed", "t", "1"];

/** Normalizes marketing consent for API. Unknown/weird values → false (no consent). */
function normalizeMarketing(value) {
  if (value === undefined || value === null) return false;
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const v = value.toLowerCase().trim();
    if (v === "" || OPT_OUT_STRINGS.includes(v)) return false;
    if (OPT_IN_STRINGS.includes(v)) return true;
    return false;
  }
  if (typeof value === "number") return value !== 0;
  return false;
}

/** Sends only API-accepted fields. Marketing normalized to truthy/falsy for backend tags. */
export const createMailchimpSubscriber = ({
  email,
  deadline = "self-paced",
  marketing,
  language = "en",
  country
}) => {
  const data = {
    email,
    deadline,
    marketing: normalizeMarketing(marketing),
    locale: language,
    courseSlug: "intro"
  };
  if (country) data.country = country;
  axios({
    method: "POST",
    url: `${BASE_URL}/create-mailchimp-subscriber`,
    data,
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(response => console.log(response.data))
    .catch(error => console.log(error));
};

/** Accepts { email, course?, locale?, country?, marketing? }. Sends only defined fields. */
export const updateMailchimpSubscriber = ({
  email,
  course = "intro",
  locale,
  country,
  marketing
}) => {
  const data = { email, course };
  if (locale != null) data.locale = locale;
  if (country != null) data.country = country;
  if (marketing !== undefined) data.marketing = normalizeMarketing(marketing);
  axios({
    method: "POST",
    url: `${BASE_URL}/update-mailchimp-subscriber`,
    data,
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(response => response.data)
    .then(json => {});
};

/** Builds update payload from user object (email + optional extra_fields). */
export const mailchimpUpdatePayloadFromUser = (user, course = "intro") => {
  const extra = user?.extra_fields || {};
  return {
    email: user.email,
    course,
    locale: extra.language,
    country: extra.country,
    marketing: extra.marketing
  };
};
